const translations = {
  en: {
    appName: "Nature Journal",
    journal: "Journal",
    gallery: "Gallery",
    species: "Species",
    stats: "Stats",
    map: "Map",
    newEntry: "New Entry",
    offline: "Offline",
    pending: "pending",
    entries: "Entries",
    photos: "Photos",
    searchEntries: "Search entries...",
    filterByTag: "Filter by tag",
    allTags: "All Tags",
    export: "Export",
    exportJournal: "Export Journal",
    exportJSON: "Export JSON",
    exportCSV: "Export CSV",
    exportPDF: "Export PDF",
    noEntries: "Your nature journal is empty. Start documenting your adventures!",
    createFirstEntry: "Create First Entry",
    back: "Back",
    edit: "Edit",
    delete: "Delete",
    share: "Share",
    shareEntry: "Share Entry",
    copyLink: "Copy link",
    location: "Location",
    weather: "Weather",
    gpsCoordinates: "GPS Coordinates",
    tags: "Tags",
    addTag: "Add tag",
    title: "Title",
    content: "Journal Entry",
    whatObserved: "What did you observe today?",
    describeObservation: "Describe your nature observation...",
    locationName: "Location Name",
    selectWeather: "Select weather",
    sunny: "Sunny",
    cloudy: "Cloudy",
    rainy: "Rainy",
    snowy: "Snowy",
    windy: "Windy",
    foggy: "Foggy",
    latitude: "Latitude",
    longitude: "Longitude",
    uploadPhotos: "Click to upload photos",
    photoFormats: "JPG, PNG, WEBP supported",
    existingPhotos: "Existing photos:",
    newPhotos: "New photos to upload:",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
    uploadingPhotos: "Uploading photos...",
    createEntry: "Create Entry",
    updateEntry: "Update Entry",
    useTemplate: "Use Template",
    chooseTemplate: "Choose a Template",
    identifySpecies: "Identify Species",
    analyzing: "Analyzing...",
    speciesIdentified: "Species Identified",
    confidence: "Confidence",
    aiInsights: "AI Insights",
    generateInsights: "Generate Insights",
    generating: "Generating...",
    clickGenerate: "Click \"Generate Insights\" to get AI-powered observations about your entry.",
    photoGallery: "Photo Gallery",
    allPhotography: "All your nature photography in one place",
    noPhotos: "No photos yet!",
    startCapturing: "Start capturing your nature observations.",
    createEntryWithPhoto: "Create Entry with Photo",
    viewEntry: "View Entry",
    speciesGallery: "Species Gallery",
    allWildlife: "All wildlife you've identified in your journal",
    documented: "documented",
    sighting: "sighting",
    sightings: "sightings",
    noSpecies: "No species identified yet!",
    uploadAndIdentify: "Upload photos and use the AI identification feature to build your personal field guide.",
    statisticsTemplates: "Statistics & Templates",
    totalSightings: "Total Sightings",
    uniqueSpecies: "Unique Species",
    categories: "Categories",
    activeMonths: "Active Months",
    seasonalSightings: "Seasonal Sightings",
    byCategory: "By Category",
    noData: "No species data yet. Identify species in your entries to see statistics!",
    mostSighted: "Most Sighted Species",
    myTemplates: "My Custom Templates",
    createTemplate: "Create Template",
    createCustomTemplate: "Create Custom Template",
    templateName: "Template Name",
    icon: "Icon",
    entryTitlePrefix: "Entry Title Prefix",
    contentTemplate: "Content Template",
    defaultTags: "Default Tags",
    noTemplates: "No custom templates yet. Create one to speed up your journaling!",
    reminders: "Reminders",
    dailyReminder: "Daily Journaling Reminder",
    reminderTime: "Reminder Time",
    reminderDescription: "You'll receive a daily notification at this time to remind you to document your nature observations.",
    disableReminders: "Disable Reminders",
    setReminder: "Set Reminder",
    yourNatureMap: "Your Nature Map",
    noMapEntries: "No entries with locations yet. Add GPS coordinates to your entries to see them on the map!",
    noTags: "No tags yet. Add tags to your entries to organize them!",
    linkToINaturalist: "Link to iNaturalist",
    iNaturalistVerified: "iNaturalist Verified",
    searchINaturalist: "Search iNaturalist species...",
    noResults: "No results found. Try a different search term.",
    scientificName: "Scientific name",
    communityObservations: "Community observations",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    language: "Language",
    print: "Print",
    printView: "Print View",
    calendar: "Calendar",
    voiceNote: "Voice Note",
    recording: "Recording...",
    tapToRecord: "Tap to record a voice note",
    transcribing: "Transcribing...",
    transcription: "Transcription",
    appendToEntry: "Append to entry",
    voiceNotes: "Voice Notes",
    noEntriesThisDay: "No entries on this day"
  },
  es: {
    appName: "Diario Natural",
    journal: "Diario",
    gallery: "Galeria",
    species: "Especies",
    stats: "Estadisticas",
    map: "Mapa",
    newEntry: "Nueva Entrada",
    offline: "Sin conexion",
    pending: "pendiente",
    entries: "Entradas",
    photos: "Fotos",
    searchEntries: "Buscar entradas...",
    filterByTag: "Filtrar por etiqueta",
    allTags: "Todas las Etiquetas",
    export: "Exportar",
    exportJournal: "Exportar Diario",
    exportJSON: "Exportar JSON",
    exportCSV: "Exportar CSV",
    exportPDF: "Exportar PDF",
    noEntries: "Tu diario natural esta vacio. Comienza a documentar tus aventuras!",
    createFirstEntry: "Crear Primera Entrada",
    back: "Volver",
    edit: "Editar",
    delete: "Eliminar",
    share: "Compartir",
    shareEntry: "Compartir Entrada",
    copyLink: "Copiar enlace",
    location: "Ubicacion",
    weather: "Clima",
    gpsCoordinates: "Coordenadas GPS",
    tags: "Etiquetas",
    addTag: "Anadir etiqueta",
    title: "Titulo",
    content: "Entrada del Diario",
    whatObserved: "Que observaste hoy?",
    describeObservation: "Describe tu observacion de la naturaleza...",
    locationName: "Nombre del Lugar",
    selectWeather: "Seleccionar clima",
    sunny: "Soleado",
    cloudy: "Nublado",
    rainy: "Lluvioso",
    snowy: "Nevado",
    windy: "Ventoso",
    foggy: "Neblinoso",
    latitude: "Latitud",
    longitude: "Longitud",
    uploadPhotos: "Haz clic para subir fotos",
    photoFormats: "JPG, PNG, WEBP soportados",
    existingPhotos: "Fotos existentes:",
    newPhotos: "Nuevas fotos para subir:",
    cancel: "Cancelar",
    save: "Guardar",
    saving: "Guardando...",
    uploadingPhotos: "Subiendo fotos...",
    createEntry: "Crear Entrada",
    updateEntry: "Actualizar Entrada",
    useTemplate: "Usar Plantilla",
    chooseTemplate: "Elegir una Plantilla",
    identifySpecies: "Identificar Especie",
    analyzing: "Analizando...",
    speciesIdentified: "Especies Identificadas",
    confidence: "Confianza",
    aiInsights: "Perspectivas IA",
    generateInsights: "Generar Perspectivas",
    generating: "Generando...",
    clickGenerate: "Haz clic en \"Generar Perspectivas\" para obtener observaciones impulsadas por IA sobre tu entrada.",
    photoGallery: "Galeria de Fotos",
    allPhotography: "Toda tu fotografia de naturaleza en un solo lugar",
    noPhotos: "Aun no hay fotos!",
    startCapturing: "Comienza a capturar tus observaciones de la naturaleza.",
    createEntryWithPhoto: "Crear Entrada con Foto",
    viewEntry: "Ver Entrada",
    speciesGallery: "Galeria de Especies",
    allWildlife: "Toda la vida silvestre que has identificado en tu diario",
    documented: "documentadas",
    sighting: "avistamiento",
    sightings: "avistamientos",
    noSpecies: "Aun no se han identificado especies!",
    uploadAndIdentify: "Sube fotos y usa la funcion de identificacion por IA para construir tu guia de campo personal.",
    statisticsTemplates: "Estadisticas y Plantillas",
    totalSightings: "Total de Avistamientos",
    uniqueSpecies: "Especies Unicas",
    categories: "Categorias",
    activeMonths: "Meses Activos",
    seasonalSightings: "Avistamientos Estacionales",
    byCategory: "Por Categoria",
    noData: "Aun no hay datos de especies. Identifica especies en tus entradas para ver estadisticas!",
    mostSighted: "Especies Mas Vistas",
    myTemplates: "Mis Plantillas Personalizadas",
    createTemplate: "Crear Plantilla",
    createCustomTemplate: "Crear Plantilla Personalizada",
    templateName: "Nombre de Plantilla",
    icon: "Icono",
    entryTitlePrefix: "Prefijo del Titulo",
    contentTemplate: "Plantilla de Contenido",
    defaultTags: "Etiquetas Predeterminadas",
    noTemplates: "Aun no hay plantillas personalizadas. Crea una para acelerar tu diario!",
    reminders: "Recordatorios",
    dailyReminder: "Recordatorio Diario del Diario",
    reminderTime: "Hora del Recordatorio",
    reminderDescription: "Recibiras una notificacion diaria a esta hora para recordarte documentar tus observaciones de la naturaleza.",
    disableReminders: "Desactivar Recordatorios",
    setReminder: "Establecer Recordatorio",
    yourNatureMap: "Tu Mapa Natural",
    noMapEntries: "Aun no hay entradas con ubicaciones. Anade coordenadas GPS a tus entradas para verlas en el mapa!",
    noTags: "Aun no hay etiquetas. Anade etiquetas a tus entradas para organizarlas!",
    linkToINaturalist: "Vincular a iNaturalist",
    iNaturalistVerified: "Verificado en iNaturalist",
    searchINaturalist: "Buscar especies en iNaturalist...",
    noResults: "No se encontraron resultados. Prueba con otro termino de busqueda.",
    scientificName: "Nombre cientifico",
    communityObservations: "Observaciones de la comunidad",
    darkMode: "Modo Oscuro",
    lightMode: "Modo Claro",
    language: "Idioma",
    print: "Imprimir",
    printView: "Vista de Impresion"
  },
  fr: {
    appName: "Journal Nature",
    journal: "Journal",
    gallery: "Galerie",
    species: "Especes",
    stats: "Stats",
    map: "Carte",
    newEntry: "Nouvelle Entree",
    offline: "Hors ligne",
    pending: "en attente",
    entries: "Entrees",
    photos: "Photos",
    searchEntries: "Rechercher des entrees...",
    filterByTag: "Filtrer par tag",
    allTags: "Tous les Tags",
    export: "Exporter",
    exportJournal: "Exporter le Journal",
    exportJSON: "Exporter JSON",
    exportCSV: "Exporter CSV",
    exportPDF: "Exporter PDF",
    noEntries: "Votre journal nature est vide. Commencez a documenter vos aventures!",
    createFirstEntry: "Creer Premiere Entree",
    back: "Retour",
    edit: "Modifier",
    delete: "Supprimer",
    share: "Partager",
    shareEntry: "Partager l'Entree",
    copyLink: "Copier le lien",
    location: "Lieu",
    weather: "Meteo",
    tags: "Tags",
    title: "Titre",
    content: "Entree du Journal",
    whatObserved: "Qu'avez-vous observe aujourd'hui?",
    cancel: "Annuler",
    save: "Enregistrer",
    createEntry: "Creer Entree",
    updateEntry: "Mettre a Jour",
    identifySpecies: "Identifier l'Espece",
    speciesIdentified: "Especes Identifiees",
    confidence: "Confiance",
    aiInsights: "Apercus IA",
    generateInsights: "Generer des Apercus",
    photoGallery: "Galerie Photo",
    speciesGallery: "Galerie des Especes",
    statisticsTemplates: "Statistiques et Modeles",
    darkMode: "Mode Sombre",
    lightMode: "Mode Clair",
    language: "Langue",
    print: "Imprimer"
  },
  de: {
    appName: "Naturtagebuch",
    journal: "Tagebuch",
    gallery: "Galerie",
    species: "Arten",
    stats: "Statistik",
    map: "Karte",
    newEntry: "Neuer Eintrag",
    offline: "Offline",
    entries: "Eintrage",
    photos: "Fotos",
    searchEntries: "Eintrage suchen...",
    export: "Exportieren",
    back: "Zuruck",
    edit: "Bearbeiten",
    delete: "Loschen",
    share: "Teilen",
    title: "Titel",
    content: "Tagebucheintrag",
    cancel: "Abbrechen",
    save: "Speichern",
    createEntry: "Eintrag Erstellen",
    identifySpecies: "Art Identifizieren",
    speciesIdentified: "Identifizierte Arten",
    aiInsights: "KI-Einblicke",
    photoGallery: "Fotogalerie",
    speciesGallery: "Artengalerie",
    darkMode: "Dunkelmodus",
    lightMode: "Hellmodus",
    language: "Sprache",
    print: "Drucken"
  },
  ja: {
    appName: "自然観察日記",
    journal: "日記",
    gallery: "ギャラリー",
    species: "種",
    stats: "統計",
    map: "マップ",
    newEntry: "新規作成",
    offline: "オフライン",
    entries: "エントリー",
    photos: "写真",
    searchEntries: "エントリーを検索...",
    export: "エクスポート",
    back: "戻る",
    edit: "編集",
    delete: "削除",
    share: "共有",
    title: "タイトル",
    content: "日記エントリー",
    cancel: "キャンセル",
    save: "保存",
    createEntry: "作成",
    identifySpecies: "種を特定",
    speciesIdentified: "特定された種",
    aiInsights: "AIインサイト",
    photoGallery: "フォトギャラリー",
    speciesGallery: "種のギャラリー",
    darkMode: "ダークモード",
    lightMode: "ライトモード",
    language: "言語",
    print: "印刷"
  },
  pt: {
    appName: "Diario da Natureza",
    journal: "Diario",
    gallery: "Galeria",
    species: "Especies",
    stats: "Estatisticas",
    map: "Mapa",
    newEntry: "Nova Entrada",
    offline: "Offline",
    pending: "pendente",
    entries: "Entradas",
    photos: "Fotos",
    searchEntries: "Buscar entradas...",
    filterByTag: "Filtrar por tag",
    allTags: "Todas as Tags",
    export: "Exportar",
    exportJournal: "Exportar Diario",
    exportJSON: "Exportar JSON",
    exportCSV: "Exportar CSV",
    exportPDF: "Exportar PDF",
    noEntries: "Seu diario da natureza esta vazio. Comece a documentar suas aventuras!",
    createFirstEntry: "Criar Primeira Entrada",
    back: "Voltar",
    edit: "Editar",
    delete: "Excluir",
    share: "Compartilhar",
    shareEntry: "Compartilhar Entrada",
    copyLink: "Copiar link",
    location: "Localizacao",
    weather: "Clima",
    gpsCoordinates: "Coordenadas GPS",
    tags: "Tags",
    addTag: "Adicionar tag",
    title: "Titulo",
    content: "Entrada do Diario",
    whatObserved: "O que voce observou hoje?",
    describeObservation: "Descreva sua observacao da natureza...",
    locationName: "Nome do Local",
    selectWeather: "Selecionar clima",
    sunny: "Ensolarado",
    cloudy: "Nublado",
    rainy: "Chuvoso",
    snowy: "Nevando",
    windy: "Ventoso",
    foggy: "Nevoeiro",
    latitude: "Latitude",
    longitude: "Longitude",
    uploadPhotos: "Clique para enviar fotos",
    photoFormats: "JPG, PNG, WEBP suportados",
    existingPhotos: "Fotos existentes:",
    newPhotos: "Novas fotos para enviar:",
    cancel: "Cancelar",
    save: "Salvar",
    saving: "Salvando...",
    uploadingPhotos: "Enviando fotos...",
    createEntry: "Criar Entrada",
    updateEntry: "Atualizar Entrada",
    useTemplate: "Usar Modelo",
    chooseTemplate: "Escolher um Modelo",
    identifySpecies: "Identificar Especie",
    analyzing: "Analisando...",
    speciesIdentified: "Especies Identificadas",
    confidence: "Confianca",
    aiInsights: "Insights de IA",
    generateInsights: "Gerar Insights",
    generating: "Gerando...",
    clickGenerate: "Clique em \"Gerar Insights\" para obter observacoes com IA sobre sua entrada.",
    photoGallery: "Galeria de Fotos",
    allPhotography: "Toda sua fotografia da natureza em um so lugar",
    noPhotos: "Nenhuma foto ainda!",
    startCapturing: "Comece a capturar suas observacoes da natureza.",
    createEntryWithPhoto: "Criar Entrada com Foto",
    viewEntry: "Ver Entrada",
    speciesGallery: "Galeria de Especies",
    allWildlife: "Toda a vida selvagem que voce identificou no seu diario",
    documented: "documentadas",
    sighting: "avistamento",
    sightings: "avistamentos",
    noSpecies: "Nenhuma especie identificada ainda!",
    uploadAndIdentify: "Envie fotos e use o recurso de identificacao por IA para construir seu guia de campo pessoal.",
    statisticsTemplates: "Estatisticas e Modelos",
    totalSightings: "Total de Avistamentos",
    uniqueSpecies: "Especies Unicas",
    categories: "Categorias",
    activeMonths: "Meses Ativos",
    seasonalSightings: "Avistamentos Sazonais",
    byCategory: "Por Categoria",
    noData: "Sem dados de especies ainda. Identifique especies em suas entradas para ver estatisticas!",
    mostSighted: "Especies Mais Avistadas",
    myTemplates: "Meus Modelos Personalizados",
    createTemplate: "Criar Modelo",
    createCustomTemplate: "Criar Modelo Personalizado",
    templateName: "Nome do Modelo",
    icon: "Icone",
    entryTitlePrefix: "Prefixo do Titulo",
    contentTemplate: "Modelo de Conteudo",
    defaultTags: "Tags Padrao",
    noTemplates: "Nenhum modelo personalizado ainda. Crie um para agilizar seu diario!",
    reminders: "Lembretes",
    dailyReminder: "Lembrete Diario do Diario",
    reminderTime: "Hora do Lembrete",
    reminderDescription: "Voce recebera uma notificacao diaria neste horario para lembrar de documentar suas observacoes da natureza.",
    disableReminders: "Desativar Lembretes",
    setReminder: "Definir Lembrete",
    yourNatureMap: "Seu Mapa da Natureza",
    noMapEntries: "Nenhuma entrada com localizacao ainda. Adicione coordenadas GPS as suas entradas para ve-las no mapa!",
    noTags: "Nenhuma tag ainda. Adicione tags as suas entradas para organiza-las!",
    linkToINaturalist: "Vincular ao iNaturalist",
    iNaturalistVerified: "Verificado no iNaturalist",
    searchINaturalist: "Buscar especies no iNaturalist...",
    noResults: "Nenhum resultado encontrado. Tente um termo diferente.",
    scientificName: "Nome cientifico",
    communityObservations: "Observacoes da comunidade",
    darkMode: "Modo Escuro",
    lightMode: "Modo Claro",
    language: "Idioma",
    print: "Imprimir",
    printView: "Visualizacao de Impressao",
    calendar: "Calendario",
    voiceNote: "Nota de Voz",
    recording: "Gravando...",
    tapToRecord: "Toque para gravar uma nota de voz",
    transcribing: "Transcrevendo...",
    transcription: "Transcricao",
    appendToEntry: "Anexar a entrada",
    voiceNotes: "Notas de Voz",
    noEntriesThisDay: "Nenhuma entrada neste dia"
  },
  zh: {
    appName: "自然日记",
    journal: "日记",
    gallery: "图库",
    species: "物种",
    stats: "统计",
    map: "地图",
    newEntry: "新建条目",
    offline: "离线",
    pending: "待处理",
    entries: "条目",
    photos: "照片",
    searchEntries: "搜索条目...",
    filterByTag: "按标签筛选",
    allTags: "所有标签",
    export: "导出",
    exportJournal: "导出日记",
    exportJSON: "导出JSON",
    exportCSV: "导出CSV",
    exportPDF: "导出PDF",
    noEntries: "你的自然日记是空的。开始记录你的探险吧！",
    createFirstEntry: "创建第一个条目",
    back: "返回",
    edit: "编辑",
    delete: "删除",
    share: "分享",
    shareEntry: "分享条目",
    copyLink: "复制链接",
    location: "位置",
    weather: "天气",
    gpsCoordinates: "GPS坐标",
    tags: "标签",
    addTag: "添加标签",
    title: "标题",
    content: "日记内容",
    whatObserved: "你今天观察到了什么？",
    describeObservation: "描述你的自然观察...",
    locationName: "地点名称",
    selectWeather: "选择天气",
    sunny: "晴天",
    cloudy: "多云",
    rainy: "雨天",
    snowy: "雪天",
    windy: "有风",
    foggy: "雾天",
    latitude: "纬度",
    longitude: "经度",
    uploadPhotos: "点击上传照片",
    photoFormats: "支持JPG、PNG、WEBP格式",
    existingPhotos: "已有照片：",
    newPhotos: "待上传的新照片：",
    cancel: "取消",
    save: "保存",
    saving: "保存中...",
    uploadingPhotos: "上传照片中...",
    createEntry: "创建条目",
    updateEntry: "更新条目",
    useTemplate: "使用模板",
    chooseTemplate: "选择模板",
    identifySpecies: "识别物种",
    analyzing: "分析中...",
    speciesIdentified: "已识别物种",
    confidence: "置信度",
    aiInsights: "AI洞察",
    generateInsights: "生成洞察",
    generating: "生成中...",
    clickGenerate: "点击\"生成洞察\"获取AI驱动的观察分析。",
    photoGallery: "照片图库",
    allPhotography: "你所有的自然摄影作品",
    noPhotos: "还没有照片！",
    startCapturing: "开始捕捉你的自然观察。",
    createEntryWithPhoto: "创建带照片的条目",
    viewEntry: "查看条目",
    speciesGallery: "物种图库",
    allWildlife: "你在日记中识别的所有野生动植物",
    documented: "已记录",
    sighting: "目击",
    sightings: "目击记录",
    noSpecies: "还没有识别物种！",
    uploadAndIdentify: "上传照片并使用AI识别功能来建立你的个人野外指南。",
    statisticsTemplates: "统计与模板",
    totalSightings: "总目击数",
    uniqueSpecies: "独特物种",
    categories: "分类",
    activeMonths: "活跃月份",
    seasonalSightings: "季节性目击",
    byCategory: "按类别",
    noData: "还没有物种数据。在条目中识别物种以查看统计！",
    mostSighted: "最常见物种",
    myTemplates: "我的自定义模板",
    createTemplate: "创建模板",
    createCustomTemplate: "创建自定义模板",
    templateName: "模板名称",
    icon: "图标",
    entryTitlePrefix: "标题前缀",
    contentTemplate: "内容模板",
    defaultTags: "默认标签",
    noTemplates: "还没有自定义模板。创建一个来加速你的记录！",
    reminders: "提醒",
    dailyReminder: "每日日记提醒",
    reminderTime: "提醒时间",
    reminderDescription: "你将在此时间收到每日通知，提醒你记录自然观察。",
    disableReminders: "关闭提醒",
    setReminder: "设置提醒",
    yourNatureMap: "你的自然地图",
    noMapEntries: "还没有带位置的条目。为你的条目添加GPS坐标以在地图上查看！",
    noTags: "还没有标签。为你的条目添加标签来组织它们！",
    linkToINaturalist: "链接到iNaturalist",
    iNaturalistVerified: "iNaturalist已验证",
    searchINaturalist: "搜索iNaturalist物种...",
    noResults: "未找到结果。尝试不同的搜索词。",
    scientificName: "学名",
    communityObservations: "社区观察",
    darkMode: "深色模式",
    lightMode: "浅色模式",
    language: "语言",
    print: "打印",
    printView: "打印预览",
    calendar: "日历",
    voiceNote: "语音笔记",
    recording: "录音中...",
    tapToRecord: "点击录制语音笔记",
    transcribing: "转录中...",
    transcription: "转录",
    appendToEntry: "附加到条目",
    voiceNotes: "语音笔记",
    noEntriesThisDay: "这一天没有条目"
  },
  ar: {
    appName: "مجلة الطبيعة",
    journal: "المجلة",
    gallery: "المعرض",
    species: "الانواع",
    stats: "الاحصائيات",
    map: "الخريطة",
    newEntry: "ادخال جديد",
    offline: "غير متصل",
    pending: "معلق",
    entries: "الادخالات",
    photos: "الصور",
    searchEntries: "البحث في الادخالات...",
    filterByTag: "تصفية حسب العلامة",
    allTags: "جميع العلامات",
    export: "تصدير",
    exportJournal: "تصدير المجلة",
    exportJSON: "تصدير JSON",
    exportCSV: "تصدير CSV",
    exportPDF: "تصدير PDF",
    noEntries: "مجلة الطبيعة الخاصة بك فارغة. ابدا بتوثيق مغامراتك!",
    createFirstEntry: "انشاء اول ادخال",
    back: "رجوع",
    edit: "تعديل",
    delete: "حذف",
    share: "مشاركة",
    shareEntry: "مشاركة الادخال",
    copyLink: "نسخ الرابط",
    location: "الموقع",
    weather: "الطقس",
    gpsCoordinates: "احداثيات GPS",
    tags: "العلامات",
    addTag: "اضافة علامة",
    title: "العنوان",
    content: "محتوى المجلة",
    whatObserved: "ماذا لاحظت اليوم؟",
    describeObservation: "صف ملاحظتك الطبيعية...",
    locationName: "اسم الموقع",
    selectWeather: "اختر الطقس",
    sunny: "مشمس",
    cloudy: "غائم",
    rainy: "ممطر",
    snowy: "ثلجي",
    windy: "عاصف",
    foggy: "ضبابي",
    latitude: "خط العرض",
    longitude: "خط الطول",
    uploadPhotos: "انقر لرفع الصور",
    photoFormats: "يدعم JPG و PNG و WEBP",
    existingPhotos: "الصور الموجودة:",
    newPhotos: "صور جديدة للرفع:",
    cancel: "الغاء",
    save: "حفظ",
    saving: "جاري الحفظ...",
    uploadingPhotos: "جاري رفع الصور...",
    createEntry: "انشاء ادخال",
    updateEntry: "تحديث الادخال",
    useTemplate: "استخدام قالب",
    chooseTemplate: "اختيار قالب",
    identifySpecies: "تحديد النوع",
    analyzing: "جاري التحليل...",
    speciesIdentified: "الانواع المحددة",
    confidence: "الثقة",
    aiInsights: "رؤى الذكاء الاصطناعي",
    generateInsights: "توليد الرؤى",
    generating: "جاري التوليد...",
    clickGenerate: "انقر على \"توليد الرؤى\" للحصول على ملاحظات مدعومة بالذكاء الاصطناعي.",
    photoGallery: "معرض الصور",
    allPhotography: "جميع صور الطبيعة الخاصة بك في مكان واحد",
    noPhotos: "لا توجد صور بعد!",
    startCapturing: "ابدا بالتقاط ملاحظاتك الطبيعية.",
    createEntryWithPhoto: "انشاء ادخال مع صورة",
    viewEntry: "عرض الادخال",
    speciesGallery: "معرض الانواع",
    allWildlife: "جميع الحياة البرية التي حددتها في مجلتك",
    documented: "موثقة",
    sighting: "مشاهدة",
    sightings: "مشاهدات",
    noSpecies: "لم يتم تحديد اي انواع بعد!",
    uploadAndIdentify: "ارفع الصور واستخدم ميزة التعرف بالذكاء الاصطناعي لبناء دليلك الميداني الشخصي.",
    statisticsTemplates: "الاحصائيات والقوالب",
    totalSightings: "اجمالي المشاهدات",
    uniqueSpecies: "انواع فريدة",
    categories: "الفئات",
    activeMonths: "الاشهر النشطة",
    seasonalSightings: "المشاهدات الموسمية",
    byCategory: "حسب الفئة",
    noData: "لا توجد بيانات انواع بعد. حدد الانواع في ادخالاتك لرؤية الاحصائيات!",
    mostSighted: "الانواع الاكثر مشاهدة",
    myTemplates: "قوالبي المخصصة",
    createTemplate: "انشاء قالب",
    createCustomTemplate: "انشاء قالب مخصص",
    templateName: "اسم القالب",
    icon: "ايقونة",
    entryTitlePrefix: "بادئة العنوان",
    contentTemplate: "قالب المحتوى",
    defaultTags: "العلامات الافتراضية",
    noTemplates: "لا توجد قوالب مخصصة بعد. انشئ واحدا لتسريع كتابة مجلتك!",
    reminders: "التذكيرات",
    dailyReminder: "تذكير يومي للمجلة",
    reminderTime: "وقت التذكير",
    reminderDescription: "ستتلقى اشعارا يوميا في هذا الوقت لتذكيرك بتوثيق ملاحظاتك الطبيعية.",
    disableReminders: "تعطيل التذكيرات",
    setReminder: "تعيين التذكير",
    yourNatureMap: "خريطتك الطبيعية",
    noMapEntries: "لا توجد ادخالات بمواقع بعد. اضف احداثيات GPS لادخالاتك لرؤيتها على الخريطة!",
    noTags: "لا توجد علامات بعد. اضف علامات لادخالاتك لتنظيمها!",
    linkToINaturalist: "ربط بـ iNaturalist",
    iNaturalistVerified: "تم التحقق من iNaturalist",
    searchINaturalist: "البحث عن انواع في iNaturalist...",
    noResults: "لم يتم العثور على نتائج. جرب مصطلح بحث مختلف.",
    scientificName: "الاسم العلمي",
    communityObservations: "ملاحظات المجتمع",
    darkMode: "الوضع الداكن",
    lightMode: "الوضع الفاتح",
    language: "اللغة",
    print: "طباعة",
    printView: "عرض الطباعة",
    calendar: "التقويم",
    voiceNote: "ملاحظة صوتية",
    recording: "جاري التسجيل...",
    tapToRecord: "اضغط لتسجيل ملاحظة صوتية",
    transcribing: "جاري النسخ...",
    transcription: "النسخ",
    appendToEntry: "اضافة الى الادخال",
    voiceNotes: "الملاحظات الصوتية",
    noEntriesThisDay: "لا توجد ادخالات في هذا اليوم"
  }
};

const languageNames = {
  en: "English",
  es: "Espanol",
  fr: "Francais",
  de: "Deutsch",
  ja: "日本語",
  pt: "Portugues",
  zh: "中文",
  ar: "العربية"
};

export { translations, languageNames };
